import { render, staticRenderFns } from "./ProjectMediacontactPartnerFeatureListItem.vue?vue&type=template&id=933d1fdc"
import script from "./ProjectMediacontactPartnerFeatureListItem.vue?vue&type=script&lang=js"
export * from "./ProjectMediacontactPartnerFeatureListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports